export const holdTimer = (node: HTMLElement, held: boolean) => {
  let current: HTMLElement | null = node

  while (current) {
    const isNotice = [...current.classList].some((className) =>
      className.endsWith('-message-notice')
    )

    if (isNotice) {
      const propsKey = Object.keys(current).find((key) =>
        key.startsWith('__reactProps')
      )

      if (!propsKey) {
        return
      }

      const props = (
        current as unknown as Record<
          string,
          {
            onMouseEnter?: (event: unknown) => void
            onMouseLeave?: (event: unknown) => void
          }
        >
      )[propsKey]
      const event = { currentTarget: current }

      if (held) {
        props?.onMouseEnter?.(event)
      } else if (!current.matches(':hover')) {
        props?.onMouseLeave?.(event)
      }

      return
    }

    current = current.parentElement
  }
}
